module.exports = __webpack_public_path__ + "static/media/zocaloPvcJ1.b40fe6d7.jpg";